module.exports = __webpack_public_path__ + "img/appAsset--certificate-ax.0751e85d.svg";